var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

import isPlainObject from 'lodash-es/isPlainObject';

export default function isStatePlainEnough(a) {
  // isPlainObject + duck type not immutable
  if (!a) return false;
  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object') return false;
  if (typeof a.mergeDeep === 'function') return false;
  if (!isPlainObject(a)) return false;
  return true;
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-persist/es/utils/isStatePlainEnough.js
// module id = 1339
// module chunks = 3